import React from 'react';
import './App.scss';
import { Provider } from 'react-redux';
import store from './redux/store';
import ThemeProvider from './components/ThemeConfigProvider/ThemeConfigProvider';
import 'material-icons/iconfont/material-icons.css';
import ErrorPage from './startup/ErrorPageComponent/ErrorPage.component';
import { useErrorStore } from './utils/authState';

function App() {
  const isFatalError = useErrorStore((state) => state.isFatalError);

  if (isFatalError) {
    return <ErrorPage onRetry={() => window.location.reload()} />;
  }

  return (
    <Provider store={store}>
      <ThemeProvider />
    </Provider>
  );
}

export default App;